import React, { useMemo } from "react";
import { Content } from "../../../components/library/content";
import Table, { TableColumns } from "../../../components/table";
import { AdvanceSalaryRepaymentDetails } from "../../../dto";
import { AdvanceSalaryDetails } from "../../../models";
import { formatDateInDDMMYYYY, formatInr } from "../../../utils";
import { findEmiDetailsByLoanId } from "./utils";

const COLUMNS_FOR_EMI_DETAILS_TABLE: TableColumns[] = [
  { label: "EMI", field: "emiNo" },
  { label: "Amount", field: "amount" },
  { label: "Posted Date", field: "postedDate" },
  { label: "Status", field: "status" },
  { label: "Paid Date", field: "paidDate" },
];

const getTableDataForEmiDetails = (data: AdvanceSalaryRepaymentDetails) => {
  return data.map(({ amount, paidDate, postedDate, ...restData }) => ({
    ...restData,
    amount: formatInr(amount),
    paidDate: formatDateInDDMMYYYY(paidDate),
    postedDate: formatDateInDDMMYYYY(postedDate),
  }));
};

interface EmiDetailsTableProps {
  loanId: string;
  advanceSalaries: AdvanceSalaryDetails;
}

export default function EmiDetailsTable({
  loanId,
  advanceSalaries,
}: EmiDetailsTableProps) {
  const emiDetails = findEmiDetailsByLoanId({ data: advanceSalaries, loanId });

  const tableDataForEmiDetails = useMemo(() => {
    return getTableDataForEmiDetails(emiDetails);
  }, [emiDetails]);

  if (!emiDetails || emiDetails.length === 0)
    return (
      <div className="d-flex align-items-center justify-content-center">
        <p className="primary-color fw-600 m-0">No EMI Details Available</p>
      </div>
    );

  return (
    <Content header={<ContentHeader />} fixedHeaderFooter>
      <Table
        columns={COLUMNS_FOR_EMI_DETAILS_TABLE}
        data={tableDataForEmiDetails}
      />
    </Content>
  );
}

function ContentHeader() {
  return <p className="primary-color fw-600 m-0">EMI Details</p>;
}
